let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gnMGO")).then(() => parcelRequire('a9EL3'));